module.exports = __webpack_public_path__ + "static/logo23-28ea3bd822780f10b2a8811455deaf35.png";